const styles = (theme) => ({
  calendar: {
    '& .rdrDateDisplayWrapper': {
      backgroundColor: theme.color.white,
    },
  },

  calendarWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
  },

  inputRange: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: theme.spacing(1),
    borderBottom: `0.2px solid ${theme.color.grey_8A}`,
  },

  inputText: {
    borderBottom: 'none',
    width: '25%',
    fontSize: theme.spacing(2),
  },

  divider: {
    display: 'flex',
    alignItems: 'center',
  },

  delimeter: {
    borderBottom: `1px solid ${theme.color.grey_8A}`,
    width: theme.spacing(1.5),
    height: theme.spacing(0),
  },

  underline: {
    '&:before': {
      borderBottom: 'none',
    },
    '&:after': {
      borderBottom: 'none',
    },
  },

  calendarButton: {
    margin: theme.spacing(2),
  },

  footer: {
    display: 'flex',
  },

  calendarStyles: {
    color: theme.color.black,
  },
});

export default styles;
